<template>
    <b-col cols="12" class="mt-3 mb-2">
        <b-card class="m-0 p-0">
            <b-row>
                <b-col>
                    <b-row cols="12" class="mb-1">
                        <b-col><p class="text-uppercase font-weight-bold infoLinkCard">{{ $t(title) }}</p></b-col>
                    </b-row>
                    <b-row cols="12">
                        <b-col>
                            <b-spinner class="align-middle" v-if="isLoading"></b-spinner>
                            <span v-else class="font-weight-bold">{{ counter }}</span> <span>{{ $t(label) }}</span>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-center align-items-center">
                    <router-link :to="computedRoute">
                        <div class="rounded-circle circularButton" style="font-size: 0;">
                            <i class="fas fa-solid fa-chevron-right mx-2 my-1" style="font-size: 1rem;"></i>
                        </div>
                    </router-link>
                </b-col>
            </b-row>
        </b-card>
    </b-col>
</template>

<script>
export default {
    name: "InfoLinkCard",
    props: {
        title: {
            required: true,
            type: String
        },
        label: {
            required: true,
            type: String
        },
        counter: {
            required: true,
            type: Number,
        },
        link: {
            required: false,
            type: String
        },
        route: {
            required: false,
            type: Object
        },
        isLoading: {
            type: Boolean,
        },
    },
    computed: {
        computedRoute() {
            return this.route || { name: this.link, query:this.query }
        }
    }
}
</script>

<style scoped>
.infoLinkCard {
    color: #a11bb3;
}

.circularButton {
    border: 2px solid;
    color: #1F2937;
}
</style>
